import { produce } from "immer";
import { resetProfile, updateProfile } from "./actions";

const initialUserState = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
};

export const userSlice = (set, get) => ({
  ...initialUserState,
});

export const userActions = (set, get) => ({
  [resetProfile]: () => {
    set(
      produce((state) => {
        state.user = { ...initialUserState };
      })
    );
  },
  [updateProfile]: (fields) => {
    set(
      produce((state) => {
        state.user = {
          ...state.user,
          ...fields,
          // isStaff: true,
        };
      })
    );
  },
});
